import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import styled from "styled-components/macro";

export const LoadingIndicator: React.FC<{ className?: string }> = ({
  className
}) => {
  return (
    <Spin
      className={className}
      indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
    />
  );
};

const LoaderLineRoot = styled.div`
  width: 100%;
  height: 3px;
  position: relative;
  overflow: hidden;
  background-color: #ddd;
  border-radius: 20px;

  &:before {
    content: "";
    position: absolute;
    left: -50%;
    height: 3px;
    width: 40%;
    background-color: coral;
    animation: lineAnim 1s linear infinite;
    border-radius: 20px;
  }

  @keyframes lineAnim {
    0% {
      left: -40%;
    }
    50% {
      left: 20%;
      width: 80%;
    }
    100% {
      left: 100%;
      width: 100%;
    }
  }
`;

export const LineLoader: React.FC<{
  className?: string;
  style?: React.CSSProperties;
}> = ({ className, style }) => {
  return <LoaderLineRoot className={className} style={style}></LoaderLineRoot>;
};
